<header>
  <app-header></app-header>
</header>
<div class="container-xxl my-md-4 bd-layout grid">
  <aside class="sidebar" *ngIf="verMenuLateral">
    <app-sidebar [verUrlRepository]="false"></app-sidebar>
  </aside>
  <main class="main">
    <router-outlet></router-outlet>
  </main>
  <app-servicios-entidades></app-servicios-entidades>
</div>
<app-note></app-note>
<footer class="footer-out" aria-label="Pie de página - Datos de contacto y enlaces de interés">
  <section class="container">
    <govco-footer-4></govco-footer-4>
  </section>
</footer>